/*
 * Copyright 2010-2016 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

import uritemplate from 'url-template';
import apiGatewayClientFactory from './lib/apiGatewayCore/apiGatewayClient';
import utils from './lib/apiGatewayCore/utils';
var apigClientFactory = {};
apigClientFactory.newClient = function (config) {
    var apigClient = { };
    if(config === undefined) {
        config = {
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            region: '',
            apiKey: undefined,
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json'
        };
    }
    if(config.accessKey === undefined) {
        config.accessKey = '';
    }
    if(config.secretKey === undefined) {
        config.secretKey = '';
    }
    if(config.apiKey === undefined) {
        config.apiKey = '';
    }
    if(config.sessionToken === undefined) {
        config.sessionToken = '';
    }
    if(config.region === undefined) {
        config.region = 'us-east-1';
    }
    //If defaultContentType is not defined then default to application/json
    if(config.defaultContentType === undefined) {
        config.defaultContentType = 'application/json';
    }
    //If defaultAcceptType is not defined then default to application/json
    if(config.defaultAcceptType === undefined) {
        config.defaultAcceptType = 'application/json';
    }

    
    // extract endpoint and path from url
    var invokeUrl = 'https://apigw-dev.tuango.ca/mcenter';
    var endpoint = /(^https?:\/\/[^\/]+)/g.exec(invokeUrl)[1];
    var pathComponent = invokeUrl.substring(endpoint.length);

    var sigV4ClientConfig = {
        accessKey: config.accessKey,
        secretKey: config.secretKey,
        sessionToken: config.sessionToken,
        serviceName: 'execute-api',
        region: config.region,
        endpoint: endpoint,
        defaultContentType: config.defaultContentType,
        defaultAcceptType: config.defaultAcceptType
    };

    var authType = 'NONE';
    if (sigV4ClientConfig.accessKey !== undefined && sigV4ClientConfig.accessKey !== '' && sigV4ClientConfig.secretKey !== undefined && sigV4ClientConfig.secretKey !== '') {
        authType = 'AWS_IAM';
    }

    var simpleHttpClientConfig = {
        endpoint: endpoint,
        defaultContentType: config.defaultContentType,
        defaultAcceptType: config.defaultAcceptType
    };

    var apiGatewayClient = apiGatewayClientFactory.newClient(simpleHttpClientConfig, sigV4ClientConfig);
    
    
    
    apigClient.claimschartDealIdMerchantIdGet = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, ['deal_id', 'merchant_id'], ['body']);
        
        var claimschartDealIdMerchantIdGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/claimschart/{deal_id}/{merchant_id}').expand(utils.parseParametersToObject(params, ['deal_id', 'merchant_id'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(claimschartDealIdMerchantIdGetRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.claimschartDealIdMerchantIdOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var claimschartDealIdMerchantIdOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/claimschart/{deal_id}/{merchant_id}').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(claimschartDealIdMerchantIdOptionsRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.dealstatsDealIdMerchantIdGet = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, ['deal_id', 'merchant_id'], ['body']);
        
        var dealstatsDealIdMerchantIdGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/dealstats/{deal_id}/{merchant_id}').expand(utils.parseParametersToObject(params, ['deal_id', 'merchant_id'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(dealstatsDealIdMerchantIdGetRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.dealstatsDealIdMerchantIdOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var dealstatsDealIdMerchantIdOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/dealstats/{deal_id}/{merchant_id}').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(dealstatsDealIdMerchantIdOptionsRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.invoiceInvoiceIdInvoiceNumberGet = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, ['invoice_id', 'invoice_number'], ['body']);
        
        var invoiceInvoiceIdInvoiceNumberGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/invoice/{invoice_id}/{invoice_number}').expand(utils.parseParametersToObject(params, ['invoice_id', 'invoice_number'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(invoiceInvoiceIdInvoiceNumberGetRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.invoiceInvoiceIdInvoiceNumberOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var invoiceInvoiceIdInvoiceNumberOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/invoice/{invoice_id}/{invoice_number}').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(invoiceInvoiceIdInvoiceNumberOptionsRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.merchantIdGet = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, ['id'], ['body']);
        
        var merchantIdGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/merchant/{id}').expand(utils.parseParametersToObject(params, ['id'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(merchantIdGetRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.merchantIdOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var merchantIdOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/merchant/{id}').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(merchantIdOptionsRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.offerlocationsDealIdGet = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, ['deal_id'], ['body']);
        
        var offerlocationsDealIdGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/offerlocations/{deal_id}').expand(utils.parseParametersToObject(params, ['deal_id'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(offerlocationsDealIdGetRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.offerlocationsDealIdOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var offerlocationsDealIdOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/offerlocations/{deal_id}').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(offerlocationsDealIdOptionsRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.resetpasswordPost = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var resetpasswordPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/resetpassword').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(resetpasswordPostRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.resetpasswordOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var resetpasswordOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/resetpassword').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(resetpasswordOptionsRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.saleschartDealIdMerchantIdGet = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, ['deal_id', 'merchant_id'], ['body']);
        
        var saleschartDealIdMerchantIdGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/saleschart/{deal_id}/{merchant_id}').expand(utils.parseParametersToObject(params, ['deal_id', 'merchant_id'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(saleschartDealIdMerchantIdGetRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.saleschartDealIdMerchantIdOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var saleschartDealIdMerchantIdOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/saleschart/{deal_id}/{merchant_id}').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(saleschartDealIdMerchantIdOptionsRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.surveystatsMerchantLocationIdGet = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, ['merchant_location_id'], ['body']);
        
        var surveystatsMerchantLocationIdGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/surveystats/{merchant_location_id}').expand(utils.parseParametersToObject(params, ['merchant_location_id'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(surveystatsMerchantLocationIdGetRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.surveystatsMerchantLocationIdOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var surveystatsMerchantLocationIdOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/surveystats/{merchant_location_id}').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(surveystatsMerchantLocationIdOptionsRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.tuangoPasswordResetPost = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var tuangoPasswordResetPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/tuango-password-reset').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(tuangoPasswordResetPostRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.tuangoPasswordResetOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var tuangoPasswordResetOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/tuango-password-reset').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(tuangoPasswordResetOptionsRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.userEmailGet = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, ['email'], ['body']);
        
        var userEmailGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/user/{email}').expand(utils.parseParametersToObject(params, ['email'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(userEmailGetRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.userEmailOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var userEmailOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/user/{email}').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(userEmailOptionsRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.useroffersUserIdGet = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, ['user_id', 'lang', 'offer_id'], ['body']);
        
        var useroffersUserIdGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/useroffers/{user_id}').expand(utils.parseParametersToObject(params, ['user_id', ])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, ['lang', 'offer_id']),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(useroffersUserIdGetRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.useroffersUserIdOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var useroffersUserIdOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/useroffers/{user_id}').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(useroffersUserIdOptionsRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.userstatsIdGet = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, ['id'], ['body']);
        
        var userstatsIdGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/userstats/{id}').expand(utils.parseParametersToObject(params, ['id'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(userstatsIdGetRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.userstatsIdOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var userstatsIdOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/userstats/{id}').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(userstatsIdOptionsRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.voucherVoucherCodeGet = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, ['voucher_code'], ['body']);
        
        var voucherVoucherCodeGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/voucher/{voucher_code}').expand(utils.parseParametersToObject(params, ['voucher_code'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(voucherVoucherCodeGetRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.voucherVoucherCodePut = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, ['voucher_code'], ['body']);
        
        var voucherVoucherCodePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/voucher/{voucher_code}').expand(utils.parseParametersToObject(params, ['voucher_code'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(voucherVoucherCodePutRequest, authType, additionalParams, config.apiKey);
    };
    
    
    apigClient.voucherVoucherCodeOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var voucherVoucherCodeOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate.parse('/voucher/{voucher_code}').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(voucherVoucherCodeOptionsRequest, authType, additionalParams, config.apiKey);
    };
    

    return apigClient;
};
export default apigClientFactory;


// WEBPACK FOOTER //
// ./src/api/apigClient.js